<template>
  <div class="km-page" :class="{ 'km-page--force': force }">
    <header class="km-top">
      <button v-if="!force" class="km-back" @click="back()" aria-label="Back">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
      </button>
      <div v-else class="km-back km-back--spacer" aria-hidden="true"></div>
      <div class="km-top__title"><span class="km-top__dot"></span><h1>{{ force ? 'Set a new password' : $t('setting.login_pwd_tip') }}</h1></div>
      <button class="km-top__save" @click="save()">{{ $t('setting.save') }}</button>
    </header>

    <main class="km-main">
      <section class="km-section">
        <div class="km-intro" :class="{ 'km-intro--force': force }">
          <div class="km-intro__ico">{{ force ? '⚠️' : '🔒' }}</div>
          <div class="km-intro__body">
            <h3>{{ force ? 'Password change required' : 'Change your login password' }}</h3>
            <p v-if="force">For your security, you must replace the temporary password before using KissMora. Enter the temp password you received, then choose a new one.</p>
            <p v-else>You'll be signed out after a successful update — use your new password next time.</p>
          </div>
        </div>

        <div class="km-card">
          <label class="km-field">
            <span class="km-field__lbl">{{ force ? 'Current (temporary) password' : $t('setting.old_pwd') }}</span>
            <input v-model="old_password" type="password" :placeholder="force ? 'Enter the temporary password' : $t('setting.old_pwd_tip')"/>
          </label>
          <label class="km-field">
            <span class="km-field__lbl">{{ $t('setting.new_pwd') }}</span>
            <input v-model="o_new_password" type="password" :placeholder="$t('setting.new_pwd_tip')"/>
          </label>
          <label class="km-field">
            <span class="km-field__lbl">{{ $t('setting.new_pwd1') }}</span>
            <input v-model="t_new_password" type="password" :placeholder="$t('setting.new_again_tip')"/>
          </label>
        </div>

        <div style="padding: 16px 4px 0;">
          <button class="km-btn" @click="save()">{{ force ? 'Save & continue' : $t('setting.save') }}</button>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      o_new_password: "",
      t_new_password: "",
      old_password: "",
      userInfo: {},
      force: false
    };
  },
  methods: {
    back() {
      if (this.force) return;
      return window.history.back();
    },
    save() {
      if (!this.o_new_password) { this.$toast.fail(this.$t("setting.prefect")); return false; }
      if (!this.t_new_password) { this.$toast.fail(this.$t("setting.prefect")); return false; }
      if (!this.old_password) { this.$toast.fail(this.$t("setting.prefect")); return false; }
      if (this.o_new_password !== this.t_new_password) { this.$toast(this.$t("setting.pwd_error")); return false; }
      if (this.o_new_password.length < 6) { this.$toast('Password must be at least 6 characters'); return false; }
      if (this.o_new_password === this.old_password) { this.$toast('Choose a different password from the temporary one'); return false; }
      this.$http({
        method: 'get',
        data: { old_password: this.old_password, new_password: this.o_new_password },
        url: 'user_set_loginpw'
      }).then(res => {
        if (res.code === 200) {
          this.$toast(res.msg || 'Password updated');
          localStorage.removeItem('must_change_password');
          setTimeout(() => {
            localStorage.clear();
            this.$router.replace({ name: 'login' });
          }, 600);
        } else if (res.code === 401 || res.code === 423) {
          this.$toast(res.msg);
        } else {
          this.$toast((res && res.msg) || 'Could not update password');
        }
      });
    },
    getUserInfo() {
      this.$http({ method: 'get', url: 'user_info' }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data || {};
          if (Number(this.userInfo.must_change_password) === 1) {
            this.force = true;
            localStorage.setItem('must_change_password', '1');
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    }
  },
  created() {
    this.force = (this.$route.query && String(this.$route.query.force) === '1')
      || localStorage.getItem('must_change_password') === '1';
    if (!localStorage.getItem('token')) this.$router.push({ path: '/Login' });
    else this.getUserInfo();
  }
};
</script>

<style lang="less" scoped>
@import "./_km-page.less";
.km-back--spacer { width: 36px; height: 36px; visibility: hidden; }
.km-intro {
  display: flex; gap: 12px; align-items: flex-start;
  padding: 14px 16px; border-radius: 16px;
  background: linear-gradient(135deg, rgba(96,165,250,.08), rgba(59,130,246,.08));
  border: 1px solid rgba(59,130,246,.18);
  margin-bottom: 14px;
}
.km-intro--force {
  background: linear-gradient(135deg, rgba(255,77,141,.10), rgba(160,32,240,.08));
  border-color: rgba(255,77,141,.25);
}
.km-intro__ico {
  width: 36px; height: 36px; border-radius: 10px;
  background: linear-gradient(135deg, #60a5fa, #3b82f6);
  display: flex; align-items: center; justify-content: center;
  font-size: 18px; flex-shrink: 0;
  box-shadow: 0 4px 10px rgba(59,130,246,.3);
}
.km-intro--force .km-intro__ico {
  background: linear-gradient(135deg, #ff4d8d, #a020f0);
  box-shadow: 0 4px 10px rgba(255,77,141,.3);
}
.km-intro__body h3 { margin: 0 0 2px; font-size: 14px; font-weight: 800; color: #2a1a3f; }
.km-intro__body p { margin: 0; font-size: 12px; color: #5a4a78; line-height: 1.5; }
</style>
